export default "__VITE_ASSET__BlgyLnRP__"